var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.333 8a6.667 6.667 0 1 0 13.334 0A6.667 6.667 0 0 0 1.333 8m12 0A5.333 5.333 0 1 1 2.667 8a5.333 5.333 0 0 1 10.666 0m-6-3.333a.667.667 0 0 1 1.334 0V8a.667.667 0 0 1-1.334 0zM8 10a.667.667 0 1 0 0 1.333A.667.667 0 0 0 8 10",
    clipRule: "evenodd"
  })));
};
export default SvgExclamation;